import { Box, Typography, useTheme } from '@mui/material';
import capitalize from '../../../utils/capitalize';

export const TitleStepe = ({ user, description, title }) => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          padding: '0 1rem',
        }}>
        <Typography
          lineHeight={'clamp(1.05rem, -0.0833rem + 3.5556vw, 1.45rem)'}
          textAlign={'center'}
          component={'p'}
          sx={{
            fontSize: theme.typography.availableBalance.fontSize,
            color: theme.palette.primary.main,
            fontWeight: theme.typography.signInWelcome.fontWeight,
            [theme.breakpoints.down('md')]: {
              fontSize: theme.typography.button.fontSize,
            },
            [theme.breakpoints.down('sm')]: {
              fontSize: theme.typography.button.fontSize,
            },
          }}>
          <Typography
            component={'span'}
            lineHeight={'clamp(1.05rem, -0.0833rem + 3.5556vw, 1.45rem)'}
            sx={{
              fontFamily: theme.typography.museoRegular.fontFamily,
              fontSize: theme.typography.h3.fontSize,
              fontWeight: theme.typography.fontWeightBold,
              color: theme.palette.secondary.text,
              [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.button.fontSize,
              },
              [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.button.fontSize,
              },
            }}>
            {capitalize(user.name)}
            {', '}
          </Typography>
          {description === null
            ? 'Puedes volver a realizar el cuestionario en cualquier momento dentro de Xcala.'
            : description}
        </Typography>
      </Box>
    </>
  );
};
